import React from 'react';
import propTypes from 'prop-types';

export const InfoCircleFillIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;

  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      fill={color}
      className={`jam jam-info-f ${variant}`}
      viewBox="-2 -2 24 24"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMinYMin"
    >
      <path d="M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-12a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1zm0-1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
    </svg>
  );
};
InfoCircleFillIcon.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
InfoCircleFillIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
